import { useEffect, useState } from "react"

// ─── Custom hook: useIsMobile ─────────────────────────────────────────────────
export function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  )

  useEffect(() => {
    let timeoutId
    const onResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => setIsMobile(window.innerWidth < breakpoint), 150)
    }
    window.addEventListener("resize", onResize)
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener("resize", onResize)
    }
  }, [breakpoint])

  return isMobile
}
